import { useState } from 'react';
import { Outlet, Link } from 'react-router-dom';
import Navbar from './home/components/Navbar';

function PhoneBanner() {
  const [visible, setVisible] = useState(true);
  if (!visible) return null;
  return (
    <div className="w-full bg-gradient-to-r from-amber-700 to-green-800 text-white py-2.5 px-4 flex items-center justify-center gap-3 relative z-50">
      <div className="w-5 h-5 flex items-center justify-center">
        <i className="ri-phone-fill text-white text-sm animate-pulse"></i>
      </div>
      <span className="text-sm font-medium">Have questions? Call us directly —</span>
      <a
        href="tel:9294738867"
        className="font-bold text-white underline underline-offset-2 hover:text-amber-200 transition-colors whitespace-nowrap cursor-pointer text-sm tracking-wide"
      >
        (929) 473-8867
      </a>
      <span className="text-white/60 text-xs hidden sm:inline">· Available 24/7</span>
      <button
        onClick={() => setVisible(false)}
        aria-label="Dismiss"
        className="absolute right-4 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center text-white/60 hover:text-white transition-colors cursor-pointer"
      >
        <i className="ri-close-line text-base"></i>
      </button>
    </div>
  );
}

const Layout = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <PhoneBanner />
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      {/* Floating Action Buttons */}
      <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">
        {/* Floating Events Button */}
        <Link
          to="/events"
          className="flex items-center gap-2 bg-pink-500 hover:bg-pink-600 text-white pl-4 pr-5 py-3 rounded-full font-semibold text-sm transition-all whitespace-nowrap cursor-pointer group"
        >
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-calendar-event-fill text-base"></i>
          </div>
          <span>Upcoming Events</span>
        </Link>
        {/* Floating Call Button */}
        <a
          href="tel:9294738867"
          className="flex items-center gap-2 bg-amber-700 hover:bg-amber-800 text-white pl-4 pr-5 py-3 rounded-full font-semibold text-sm transition-all whitespace-nowrap cursor-pointer"
        >
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-phone-fill text-base animate-pulse"></i>
          </div>
          <span>(929) 473-8867</span>
        </a>
      </div>
    </div>
  );
};

export default Layout;
